import { createSlice } from "@reduxjs/toolkit";

const CapWorksLenderDeactivationReason = "CapWorksLenderDeactivationReason";

const initialState = {
  capWorksLenderDeactivationReasons: [],
};

const capWorksLenderDeactivationReasonSlice = createSlice({
  name: CapWorksLenderDeactivationReason,
  initialState,
  reducers: {
    populateCapWorksLenderDeactivationReason(state, action) {
      state.capWorksLenderDeactivationReasons = action.payload;
    },
  },
});

export const { populateCapWorksLenderDeactivationReason } = capWorksLenderDeactivationReasonSlice.actions;

export default capWorksLenderDeactivationReasonSlice.reducer;
